import React, {useCallback, useEffect, useState} from 'react'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import Sidebar from './sidebar/sidebar'

/* 메인 기능들 */
// import AnnouncementComp from './main/announcement/announcement-comp'
import UserCompanyInfo from './main/standard-info/user-company-info/user-company-info'
import StandardCode from './main/standard-info/standard-code/standard-code'
import Customer from './main/standard-info/customer/customer'
import Product from './main/standard-info/product/product'
import StockStatus from './main/stock-manage/stock-status/stock-status'
import InitialStock from './main/stock-manage/initial-stock/initial-stock'
import GoodsBuySell from './main/in-out-manage/goods-buy-sell/goods-buying'
import AddRecipe from "./main/production-manage/add-recipe/add-recipe";
import ProductionPerformance from "./main/production-manage/input-prod-perf/production-performance";
import StockPay from "./main/stock-manage/stock-pay/stock-pay";
import ProdDaily from "./main/production-manage/prod-daily/prod-daily";

import {RootReducer} from '../redux/reducers'
import client from '../axios'
import * as timerActions from '../redux/actions/timer'
import {useNavigate} from 'react-router-dom'
import InfoModal from './common-modals/info-modal'

import MatPay from "./main/stock-manage/mat-pay/mat-pay";
import * as currentPageActions from '../redux/actions/current-page'
import * as decActions from '../redux/actions/dec'
import * as changeMenuActions from '../redux/actions/change-menu'

import 'bootstrap-icons/font/bootstrap-icons.css'

import {Modal} from "react-bootstrap";
import Settings from "./main/settings/settings";
import ExcelApply from "./main/standard-info/excel-apply/ExcelApply";
import Temperature from './main/temperature/Temperature';
import Devices from './main/temperature/Devices'

const Index = () => {

  /* 현재 페이지 */
  const {current_page, open_tabs} = useSelector((state: RootReducer) => state.currentPage, shallowEqual)
  const [errorMsg, setErrorMsg] = useState('')
  const [showErrorMsg, setShowErrorMsg] = useState(false)
  const [currentComponent, setCurrentComponent] = useState('dashboard')
  const navigate = useNavigate()
  const dispatch = useDispatch()



  useEffect(() => {
    client.get('/api/auth/get-user-profile')
      .then(res => {
        if (res.data.admin_gbn === '3') {
          dispatch(currentPageActions.temperature());
          setCurrentComponent('temperature');
        } else {
          setCurrentComponent('dashboard');
        }
      })
  }, [])

  /* store의 currentPage state에 따라 보이는 컴포넌트 반환 */
  const getComponentById = (id: string) => {
    switch (id) {
      // case 'dashboard':
      //     return <AnnouncementComp />

      case 'input-buy':
        return <GoodsBuySell buySellMode={1}/>
      case 'input-sell':
        return <GoodsBuySell buySellMode={2}/>

      case 'prod-perf':
        return <ProductionPerformance/>
      case 'stock-pay':
        return <StockPay/>
      case 'mat-pay':
        return <MatPay/>

      case 'stock-status':
        return <StockStatus/>
      case 'initial-stock':
        return <InitialStock/>
      case 'prod-daily':
        return <ProdDaily/>

      case 'user-com':
        return <UserCompanyInfo/>
      case 'standard-code':
        return <StandardCode/>
      case 'customer':
        return <Customer/>
      case 'product':
        return <Product/>
      case 'add-recipe':
        return <AddRecipe/>
      case 'excel-apply':
        return <ExcelApply />

      case 'settings':
        return <Settings/>

      case 'temperature':
        return <Temperature />

      case 'devices':
        return <Devices />

      // default:
      //     return <AnnouncementComp />
      default:
        return <></>
    }
  }

  useEffect(() => {
    client.get('/api/settings/get-dec')
      .then(res => dispatch(decActions.setDec(res.data.payload.dec)))
      .catch(() => {
        setErrorMsg('데이터 불러오기에 실패했습니다.')
        setShowErrorMsg(true)
      })
  }, [])

  useEffect(() => {
    client.get('/api/auth/extend-login')
      .then(res => {
        if (res.data.result !== 'success') {
          dispatch(changeMenuActions.reset())
          dispatch(currentPageActions.logout())
          navigate('/login')
        } else {
          dispatch(timerActions.reset())
        }
      })
      .catch(() => {
        setErrorMsg('로그인 연장에 에러가 발생하였습니다.')
        setShowErrorMsg(true)
      })
  }, [navigate, current_page, dispatch])

  useEffect(() => {
    setCurrentComponent(current_page)
  }, [current_page])

  return (
    <>
      <div className="container-fluid d-flex">
        <div className="row vw-100">
          <Sidebar/>
          <main className="py-2 main position-relative">
            {open_tabs && open_tabs.map(tabId => (
              <div key={tabId} style={{ display: tabId === currentComponent ? 'block' : 'none', height: '100%' }}>
                {getComponentById(tabId)}
              </div>
            ))}
            
            {/* Render currentComponent if it's not in open_tabs (e.g. dashboard) */}
            {(!open_tabs || !open_tabs.includes(currentComponent)) && (
              <div style={{ height: '100%' }}>
                {getComponentById(currentComponent)}
              </div>
            )}
          </main>
        </div>
      </div>

      <InfoModal show={showErrorMsg} onHide={() => setShowErrorMsg(false)} title={'오류'} message={errorMsg}
                 onButtonClick={() => setShowErrorMsg(false)}/>


    </>
  )
}

export default Index